export default __webpack_public_path__ + "static/media/image_14.0f5a7972.png";